import SweetScroll from 'sweet-scroll';
var default_1 = /** @class */ (function () {
    function default_1() {
        this.PageScroll();
    }
    default_1.prototype.PageScroll = function () {
        var options = {
            trigger: '[data-scroll]',
            header: '[data-scroll-header]',
            duration: 1000,
            easing: 'easeOutQuint',
            offset: -18,
            // updateURL: false,
        };
        var scroller = new SweetScroll(options);
    };
    return default_1;
}());
export default default_1;
